import { operatorDefinitions } from './operatorDefinitions';

// Array of operatorDefinition objects
export const operatorDefinitionsList = Object.values(operatorDefinitions);
